import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { useAuth } from "@/context/AuthContext";
import { Building, Building2, ClipboardList, Check, ArrowRight, Rocket } from "lucide-react";

export default function OnboardingGuide({ hasOperations }) {
  const { sites, entreprises } = useApp();
  const { user } = useAuth();
  const nav = useNavigate();

  const steps = [
    { key: "site", icon: Building, label: "Créez votre premier site", desc: "Le lieu où se déroulent vos interventions.", done: sites.length > 0, to: "/sites", cta: "Créer un site" },
    { key: "ent", icon: Building2, label: "Ajoutez une entreprise extérieure", desc: "Les intervenants qui travaillent sur vos sites.", done: entreprises.length > 0, to: "/sites", cta: "Ajouter une entreprise" },
    { key: "op", icon: ClipboardList, label: "Lancez votre première opération", desc: "Le parcours de prévention en 8 étapes.", done: hasOperations, to: "/operations/new", cta: "Nouvelle opération", locked: sites.length === 0 },
  ];
  const activeIdx = steps.findIndex((s) => !s.done);

  return (
    <div className="onboarding card" data-testid="onboarding-guide">
      <div className="onboarding-head">
        <div className="onboarding-badge"><Rocket size={22} /></div>
        <div>
          <h2 style={{ fontSize: "1.3rem" }}>Bienvenue{user?.name ? `, ${user.name.split(" ")[0]}` : ""} 👋</h2>
          <p style={{ fontSize: ".85rem", color: "var(--text-muted)", marginTop: 4 }}>
            {user?.organisation ? `${user.organisation} — ` : ""}Configurons votre espace en 3 étapes. Votre organisation est entièrement isolée.
          </p>
        </div>
      </div>

      <div className="onboarding-steps">
        {steps.map((s, i) => {
          const isActive = i === activeIdx;
          return (
            <div key={s.key} className={`onboarding-step ${s.done ? "done" : ""} ${isActive ? "active" : ""}`} data-testid={`onboarding-step-${s.key}`}>
              <div className="ob-num">{s.done ? <Check size={16} /> : <s.icon size={16} />}</div>
              <div className="ob-body">
                <div className="ob-label">{s.label}</div>
                <div className="ob-desc">{s.desc}</div>
              </div>
              {!s.done && (
                <button className={`btn ${isActive && !s.locked ? "btn-p" : "btn-g"} btn-sm`} disabled={s.locked}
                  onClick={() => nav(s.to)} data-testid={`onboarding-cta-${s.key}`}>
                  {s.cta}<ArrowRight size={13} />
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
